import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAllRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";
import { AccountViewer } from "components/form/graphql/types";

export const STACK_MANAGE_ACCESS_TYPES = [Action.SpaceAdmin, Action.StackManage];

const hasCreateAccess = (viewer: AccountViewer) =>
  !!STACK_MANAGE_ACCESS_TYPES.find((action) => hasAllRequiredActionsInAnySpace([action], viewer));

/**
 * Hook that returns whether current user can create stack
 * User needs to have SpaceAdmin or StackManage actions in at least one space
 * @returns {AccessResult} Object indicating if user can create stack and a message if not
 */
const useCanCreateStack = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasCreateAccess(viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateStack;
